import * as React from 'react';

import { useContext } from '../../../utils/useContext';
import { DealType } from '../../../components/advancedFilters/DealType';
import { useOfferType } from '../../../utils/useOfferType';
import { useDealType } from '../../../utils/useDealType';
import { getTermValue } from '../../../../../JsonQuery';
import { isDealRentEnabled } from '../../../utils/location';

export const DealTypeContainer: React.FC = () => {
  const { jsonQuery, currentLocation, onChange } = useContext();
  const isDealRentFilterEnabled = isDealRentEnabled(currentLocation);
  const dealType = useDealType();
  const offerType = useOfferType();
  const isDealRent = getTermValue('deal_rent')(jsonQuery);
  const isByHomeowner = getTermValue('is_by_homeowner')(jsonQuery);
  const isFromOffrep = getTermValue('from_offrep')(jsonQuery);

  const handleIsByHomeownerChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setIsByHomeowner', arguments: [value] });
    },
    [onChange],
  );

  const handleIsFromOffrepChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setFromOffrep', arguments: [value] });
    },
    [onChange],
  );

  const handleIsDealRentChange = React.useCallback(
    (value: boolean | null) => {
      onChange({ action: 'setDealRent', arguments: [value] });
    },
    [onChange],
  );

  return (
    <DealType
      dealType={dealType}
      offerType={offerType}
      isDealRentEnabled={isDealRentFilterEnabled}
      isDealRent={isDealRent}
      isByHomeowner={isByHomeowner}
      isFromOffrep={isFromOffrep}
      onIsByHomeownerChange={handleIsByHomeownerChange}
      onIsFromOffrepChange={handleIsFromOffrepChange}
      onIsDealRentChange={handleIsDealRentChange}
    />
  );
};
